export default __webpack_public_path__ + "static/media/liter.d1208cc9.svg";